import { render, staticRenderFns } from "./SelectProfileTypeForPrefilledDocumentModal.vue?vue&type=template&id=611cd09b&scoped=true&"
import script from "./SelectProfileTypeForPrefilledDocumentModal.vue?vue&type=script&lang=ts&"
export * from "./SelectProfileTypeForPrefilledDocumentModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611cd09b",
  null
  
)

export default component.exports